import { addCommasFor } from 'components/vars/common/FormatNumber';
import { TFunction } from 'i18next';

// useKFrgnCurPaymentColDef와 useKFrgnCurPaymentAdColDefs 동일해서 공통으로 사용하도록 columns 디렉토리 생성 함
export const useKFrgnCurPaymentComColDefs = (t: TFunction) => [
  {
    headerName: t('com.label.00113', '__지급일자'),
    headerTooltip: t('com.label.00113', '__지급일자'),
    field: 'payDt',
    tooltipField: 'payDt',
    maxWidth: 200,
  },
  {
    headerName: t('com.label.00076', '__통화'),
    headerTooltip: t('com.label.00076', '__통화'),
    field: 'curr',
    tooltipField: 'curr',
    maxWidth: 120,
  },
  {
    headerName: t('com.label.00118', '__금액'),
    headerTooltip: t('com.label.00118', '__금액'),
    field: 'payAmt',
    tooltipField: 'payAmt',
    cellStyle: { textAlign: 'right' },
    valueFormatter: (params) => addCommasFor(params.value),
    flex: 1,
  },
  {
    headerName: t('com.label.00119', '__지급은행'),
    headerTooltip: t('com.label.00119', '__지급은행'),
    field: 'payBankNm',
    tooltipField: 'payBankNm',
    cellStyle: { textAlign: 'center' },
    flex: 1,
  },
  {
    headerName: t('Swift', 'Swift'),
    headerTooltip: t('Swift', 'Swift'),
    field: 'swift',
    tooltipField: 'swift',
    cellStyle: { textAlign: 'left' },
    maxWidth: 200,
  },
  {
    headerName: t('com.label.00070', '__계좌번호'),
    headerTooltip: t('com.label.00070', '__계좌번호'),
    field: 'accnNo',
    tooltipField: 'accnNo',
    flex: 1,
  },
  {
    headerName: t('com.label.00130', '__전문번호'),
    headerTooltip: t('com.label.00130', '__전문번호'),
    field: 'profNo',
    tooltipField: 'profNo',
    maxWidth: 200,
  },
];
